import React, { useMemo } from 'react';
import { Card } from 'react-bootstrap';
// import { ChartFactory } from '../../../../../AIDashboard/AIDashboard/utils';
import { ChartFactory } from '../../../../../ChartUtility/charts';

// Mapping from the provided source
const IntensityUnitMap = {
  CarbonIntensity: 'kg CO₂e',
  WaterIntensity: 'kL',
  WasteIntensity: 'Kg',
  HazardousWasteIntensity: 'Kg',
  NonHazardousWasteIntensity: 'Kg',
  BioMedicalWasteIntensity: 'Kg',
  FuelIntensity: 'GJ',
  RenewableEnergyIntensity: 'kWh',
  ElectricityIntensity: 'kWh',
};

const IntensityGraphCard = ({ rawData, selectedIntensityType, selectedPeriodsValue, selectedLocations, targetKpi }) => {
  
  const processedData = useMemo(() => {
    if (!rawData.length || !selectedIntensityType || !selectedPeriodsValue.length) return [];

    const validLocIds = selectedLocations.map(id => id.toString());
    const validMonths = selectedPeriodsValue.map(p => p.fromDate.substring(0, 7));

    // Determine the combined unit (e.g., GJ/Cr)
    const numeratorUnit = IntensityUnitMap[selectedIntensityType.value] || '';
    let denominatorUnit = '';
    
    if (targetKpi.includes('Cr')) denominatorUnit = 'Cr';
    else if (targetKpi.includes('sq. ft')) denominatorUnit = 'sq. ft';
    else if (targetKpi.includes('Served')) denominatorUnit = 'Patient';
    else if (targetKpi.includes('Beds')) denominatorUnit = 'Bed';

    const finalUnit = numeratorUnit && denominatorUnit ? `${numeratorUnit}/${denominatorUnit}` : numeratorUnit;

    const periodSums = selectedPeriodsValue.reduce((acc, p) => {
      acc[p.label] = { metricValue: 0, answer: 0 };
      return acc;
    }, {});

    rawData.forEach(item => {
      const month = item.fromDate.substring(0, 7);

      if (
        item.type === selectedIntensityType.value &&
        validLocIds.includes(item.sourceId?.toString()) &&
        validMonths.includes(month)
      ) {
        const periodLabel = selectedPeriodsValue
          .find(p => p.fromDate.startsWith(month))?.label;

        if (!periodLabel) return;

        const ansData = item.intensityQuestionAnswers?.find(a => a.title === targetKpi);
        const answer = parseFloat(ansData?.answer || 0);
        const metricValue = parseFloat(ansData?.metricValue || 0);

        periodSums[periodLabel].metricValue += metricValue;
        periodSums[periodLabel].answer += answer;
      }
    });

    return selectedPeriodsValue.map(p => {
      const data = periodSums[p.label];
      return {
        displayPeriods: p.label,
        kpi: targetKpi,
        sum_value:
          data.answer > 0 && data.metricValue > 0
            ? data.metricValue / data.answer
            : 0,
        unit: finalUnit,
      };
    });
  }, [rawData, selectedIntensityType, selectedPeriodsValue, selectedLocations, targetKpi]);
  let group_by = ['displayPeriods', 'kpi']

  return (
    <Card className="h-100 border-0 shadow-sm" style={{ overflow: 'visible' }}>
      <Card.Header className="bg-white border-0 pt-3">
        <h6 className="mb-0 fw-bold text-secondary">{targetKpi}</h6>
      </Card.Header>
      <Card.Body>
        {processedData.length > 0 ? (
          <ChartFactory
            chartData={{ 
              data: processedData, 
              chartType: 'line', 
            }}
            chartOptions={{ height: 350, stacked: false, transform: true }}
            group_by = {group_by}
          />
        ) : <div className="text-center py-5 text-muted small">No data available for current selection.</div>}
      </Card.Body>
    </Card>
  );
};

export default IntensityGraphCard;